import React from "react";

import "./componentStyles/common.scss";
import { CircularProgress } from "@material-ui/core";

const DefaultLoader = (props) => {
  const { message, displayModal, closeButton, contentStyle = {}, overlayStyle ={} } = props;
  const divStyle = {
    display: displayModal ? "block" : "none",
  };
  function closeModalFunc(e) {
    e.stopPropagation();
    if(props?.closeModal){
      props.closeModal();
    }
  }
  return (
    <div className="custom_modal" onClick={closeModalFunc} style={{...divStyle, ...overlayStyle}}>
      <div
        className="custom_modal-content"
        onClick={(e) => e.stopPropagation()}
        style={contentStyle}
      >
        {closeButton && (
          <span className="close" onClick={closeModalFunc}>
            &times;
          </span>
        )}
        <div className="custom_modal-flex">
          <CircularProgress
            // variant="determinate"
            // // className={classes.bottom}
            size={20}
            thickness={6}
            // {...props}
            // value={100}
          />
          <div className="custom_modal_static-msg">Please wait...</div>
          <div className="custom_modal_dynamic-msg">{message}</div>
        </div>
      </div>
    </div>
  );
};

export default DefaultLoader;
